import { defineComponent as _defineComponent } from 'vue'
import type { ManageBookingParsedOrderItem } from '@white-label-types/parking-booking';

type Bundle = {
  id: string | number;
  name: string;
  items: ManageBookingParsedOrderItem[];
};

interface Props {
  bundle: Bundle;
  wrapperClass?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-booking-bundle-container',
  props: {
    bundle: null,
    wrapperClass: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})